const scrollListener = handler => {
  const rootNode = document.getElementById('content');
  rootNode.addEventListener('scroll', handler);
};

export default scrollListener;
